import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import BundleList from './BundleList';
import CreateBundle from './CreateBundle';
import UploadXLS from './XLSUpload/UploadXLS';
import ProcessDetail from '../ProcessDetail';
import DocumentUpdateView from '../DocumentUpdate';
import { useTranslation } from 'react-i18next';
import API from '../../api-graphql';
import API_REST from '../../api-rest-uruk';
import { CONSTANTS } from '../../constants/constants';
import PageContentError from '../UI/PageContentError';

const BundleRoute = () => {
  const match = useRouteMatch();
  const { path } = match;
  const { t } = useTranslation();

  const getBundleData = async (setMessage, setItem, setError, setLoading, id, appConfig) => {
    setMessage(t('processDetail:loading'));
    try {
      const result = await API.getBundle(id);
      const bundle = result.data.getBundle;
      let nextToken = bundle.document.nextToken;
      while (nextToken) {
        const intemediateResult = await API.getBundle(id, nextToken);
        bundle.document.items = [...bundle.document.items, ...intemediateResult.data.getBundle.document.items];
        nextToken = intemediateResult.data.getBundle.document.nextToken;
      }
      const flowTemplate = appConfig.flows.find(flow => flow.templateId === bundle.flowTemplateId);
      bundle.templateName = flowTemplate ? flowTemplate.name : bundle.flowTemplateId;
      const templateSteps = flowTemplate ? flowTemplate.steps.map(step => {
        let templateStep = step.configStep.step;
        if (step.extraConfig && step.extraConfig.data) {
          const extraConfigStep = JSON.parse(step.extraConfig.data);
          templateStep = { ...templateStep, ...extraConfigStep };
        }
        return templateStep;
      }) : [];
      if (!bundle.flow) {
        bundle.flow = {
          flowId: '',
          steps: templateSteps.reduce((acc, s, i) => {
            const step = s;
            step.order = i;
            step.status = CONSTANTS.STEP.STATUS.INIT;
            acc.push(step);
            return acc;
          }, [])
        };
      }
      setItem(bundle);
    } catch (error) {
      console.error('ERROR getting bundle', error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const launchBundle = async (setMessage, setLoading, setItem, item, context, setError) => {
    setMessage(t('bundleMenu:launchingBundle'));
    setLoading(true);
    API_REST.launchBundle(
      {
        bundleId: item.id,
        contextId: context.id,
        bundleVersion: item.bundleVersion
      }
    ).then(async () => {
      let result = await API.getBundle(item.id);
      setItem(result.data.getBundle);
      setMessage(t('bundleMenu:ready'));
      setTimeout(() => setLoading(false), 2000);
    }).catch((err) => {
      console.error('[ERROR]: ', err);
      setLoading(false);
      setMessage(t('bundleMenu:error'));
      setError(err);
    });
  };
  return (
    <Switch>
      <Route path={`${path}/detail/:id`} render={(props) => (<ProcessDetail {...props} type={'bundle'} launch={launchBundle} getItemData={getBundleData} />)} />
      <Route exact path={`${path}`} render={(routeProps) => (<BundleList {...routeProps} />)} />
      <Route path={`${path}/new`} component={CreateBundle} />
      <Route path={`${path}/upload/:bundleId`} component={UploadXLS} />
      <Route path={`${path}/update/:number`} component={DocumentUpdateView} />
      <Route path='*' component={PageContentError} />
    </Switch>
  );
};

export default BundleRoute;
